document.addEventListener('theme:cart:loaded', addGiftCheckboxEvent);
document.addEventListener('theme:cart:added', addGiftCheckboxEvent);

function addGiftCheckboxEvent() {
  const cartItems = document.querySelectorAll('.cart__item');
  cartItems.forEach((cartItem) => {
    const giftCheckbox = cartItem.querySelector(`#is-gift-${cartItem.dataset.item.split(":")[0]}`)
    giftCheckbox?.addEventListener('change', async (ev) => {
      const lineItemId = cartItem.dataset.item.split(":")[0];
      const giftProperty = ev.target.checked;

      await updateLineItemGiftProperty(lineItemId, giftProperty);
      document.dispatchEvent(new CustomEvent('theme:cart:add'));
    });
  });
}

async function updateLineItemGiftProperty(lineItemId, giftProperty) {
  try {
    const cartResponse = await fetch('/cart.js');
    const cartData = await cartResponse.json();
    const lineItemIdNumber = parseInt(lineItemId);
    const lineItem = cartData.items.find(item => item.id === lineItemIdNumber);

    if (!lineItem) return;

    return await fetch('/cart/change', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        id: lineItemId,
        quantity: lineItem.quantity,
        properties: {
          ...lineItem?.properties,
          "_isGift": giftProperty,
        },
      })
    });
  }
  catch (error) {
    console.error("Error updating line item gift property", error);

  }
}
